import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgArrayPipesModule } from 'ngx-pipes';
import { UiSwitchModule } from 'ngx-toggle-switch';
// import { AngularDateTimePickerModule } from 'angular2-datetimepicker';
import { AppComponent } from './app.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { AuditsComponent } from './modules/audits/audits.component';
import { AccountsComponent } from './modules/accounts/accounts.component';
import { CustomerComponent } from './modules/customer/customer.component';
import { MaintanenceComponent } from './modules/maintanence/maintanence.component';
import { MatPaginatorCustom } from './services/matpaginatorCustom';
import { LoginComponent } from './login/login.component';
import { AuthenticationService } from './services/authentication.service';
import { HttpClientModule, HTTP_INTERCEPTORS, } from '@angular/common/http';
import { User } from './models/user';
import { RenewLicense } from './models/renewLicense';
import { AppheaderComponent } from './appheader/appheader.component';
import { AppfooterComponent } from './appfooter/appfooter.component';
import { AppsettingsComponent } from './appsettings/appsettings.component';
import { AppmenuComponent } from './appmenu/appmenu.component';
import { AppRouting } from './app.routing';
import { HealthComponent } from './modules/health/health.component';
import { DashboardService } from './services/dashboard.service';
import { CommonfilterService } from './services/commonfilter.service';
import { AuditService } from './services/audit.service';
import { PaginationService } from './services/pagination.service';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from './guards/auth.guard';
import { DateFormatPipe } from './pipes/dateFormat.pipe';
import { CustomerService } from './services/customer.service';
import { CouponService } from './services/coupon.service';
import { AccountListComponent } from './modules/accounts/account-list/account-list.component';
import { AccountHomeComponent } from './modules/accounts/account-home/account-home.component';
import { HealthService } from './services/health.service';
import { JaldeeReportService } from './services/jaldee-report.service';
import { AccountService } from './services/account.service';
import { MaintenanceService } from './services/maintenance.service';
import { AccountDataSourceService } from './services/account-data-source.service';
import { AccountResolverService } from './services/account-resolver.service';
import { JaldeeReportResolverService } from './services/jaldeeReport-resolver.service';
import { FileUploadService } from './services/file-upload.service';
import { AuthInterceptorService } from './services/auth-interceptor.service';
import { DeleteCustomerDialogComponent } from './modules/customer/delete-customer-dialog/delete-customer-dialog.component';
import { ViewHealthComponent } from './modules/health/view-health/view-health.component';
import { ListHealthComponent } from './modules/health/list-health/list-health.component';
import { ChangePasswordDialogComponent } from './appheader/change-password-dialog/change-password-dialog.component';
import { ChangeStatusDialogComponent } from './modules/customer/change-status-dialog/change-status-dialog.component';
import { DeleteAccountDialogComponent } from './modules/accounts/delete-account-dialog/delete-account-dialog.component';
import { ChangeAccstatusDialogComponent } from './modules/accounts/change-accstatus-dialog/change-accstatus-dialog.component';
import { BreadcrumbComponent } from './general/breadcrumb/breadcrumb.component';
import { AccountFilterComponent } from './modules/accounts/account-filter/account-filter.component';
import { AccountDetailsComponent } from './modules/accounts/view-account/account-details/account-details.component';
import { PaymentSettingsComponent } from './modules/accounts/view-account/payment-settings/payment-settings.component';
import { InvoicesComponent } from './modules/accounts/view-account/invoices/invoices.component';
import { TransactionsComponent } from './modules/accounts/view-account/transactions/transactions.component';
import { ViewAccountComponent } from './modules/accounts/view-account/view-account.component';

import { ViewCustomerComponent } from './modules/customer/view-customer/view-customer.component';
import { ListCustomerComponent } from './modules/customer/list-customer/list-customer.component';

import { InvoiceDialogComponent } from './modules/accounts/view-account/invoices/invoice-dialog/invoice-dialog.component';
import { MessageDisplayModule } from './shared/validation-messages-display/message-display.module';
import { DisplayResultDialogComponent } from './modules/dashboard/display-result-dialog/display-result-dialog.component';
import { GatewayDialogComponent } from './modules/accounts/view-account/payment-settings/gateway-dialog/gateway-dialog.component';
import { ConfirmEqualValidatorDirective } from './shared/confirm-equal-validator.directive';

import { SupportLoginComponent } from './support/support-login/support-login.component';
import { SupportDashboardComponent } from './support/support-dashboard/support-dashboard.component';
import { SupportHomeComponent } from './support/support-home/support-home.component';

import { SupportAccountService } from './services/support/support-account.service';
import { SupportAccountDataSourceService } from './services/support/support-account-data-source.service';
import { SupportAccountsComponent } from './support/support-accounts/support-accounts.component';
import { VerifyAccountDialogComponent } from './shared/components/verify-account-dialog/verify-account-dialog.component';
import { SupportMainComponent } from './support/support-main/support-main.component';
import { VerifyModalComponent } from './shared/components/verify-modal/verify-modal.component';
// tslint:disable-next-line:max-line-length
import { PaytmVerifyDialogComponent } from './modules/accounts/view-account/payment-settings/paytm-verify-dialog/paytm-verify-dialog.component';
import { MerchantidDialogComponent } from './modules/accounts/view-account/payment-settings/merchantid-dialog/merchantid-dialog.component';
import { LocationStrategy, HashLocationStrategy, TitleCasePipe } from '@angular/common';
// tslint:disable-next-line:max-line-length
import { RemoveadwordDialogComponent } from './modules/accounts/view-account/account-details/removeadword-dialog/removeadword-dialog.component';
// tslint:disable-next-line:max-line-length
import { ChangeSubscriptionDialogComponent } from './modules/accounts/view-account/license-details/change-subscription-dialog/change-subscription-dialog.component';
import { EmailVerifyDialogComponent } from './shared/components/email-verify-dialog/email-verify-dialog.component';
import { SafePipe } from './pipes/safe.pipe';
import { CouponListComponent } from './modules/coupons/coupon-list/coupon-list.component';
import { CouponsComponent } from './modules/coupons/coupons.component';
import { CreateCouponDialogComponent } from './modules/coupons/coupon-list/create-coupon-dialog/create-coupon-dialog.component';
import { DeleteCouponComponent } from './modules/coupons/coupon-list/delete-coupon/delete-coupon.component';
import { DisableCouponComponent } from './modules/coupons/coupon-list/disable-coupon/disable-coupon.component';
import { PushCouponComponent } from './modules/coupons/coupon-list/push-coupon/push-coupon.component';
import { ViewCouponComponent } from './modules/coupons/coupon-list/view-coupon/view-coupon.component';
import { ReportsComponent } from './modules/reports/reports.component';
import { JaldeeReportComponent } from './modules/reports/jaldee-report/jaldee-report.component';
import { ViewJaldeeReportComponent } from './modules/reports/view-jaldee-report/view-jaldee-report.component';
import { ReimburseDialogComponent } from './modules/reports/reimburse-dialog/reimburse-dialog.component';
import { ChangeInvoiceStatusDialogComponent } from './modules/reports/change-invoice-status-dialog/change-invoice-status-dialog.component';
import { AccountPaymentListComponent } from './modules/accounts/account-payment-list/account-payment-list.component';
import { AwsSearchComponent } from './modules/accounts/aws-search/aws-search.component';
import { CommonAccountFilterComponent } from './modules/accounts/common-account-filter/common-account-filter.component';
import { SharedServices } from './services/shared-services';
import { SearchDataStorageService } from './services/search-datastorage.services';
import { ServiceMeta } from './services/service-meta';
import { SharedFunctions } from './shared/functions/shared-functions';
import { ChangePhoneNumberComponent } from './modules/accounts/change-phone-number/change-phone-number.component';
import { SearchDetailComponent } from './modules/accounts/search-detail/search-detail.component';
import { SearchDetailServices } from './modules/accounts/search-detail/search-detail-services.service';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { DeleteAccountVerifyComponent } from './modules/accounts/account-filter/delete-account-verify/delete-account-verify.component';
import { MarkAsPaidComponent } from './modules/accounts/view-account/invoices/mark-as-paid/mark-as-paid.component';
import { CorporatesComponent } from './modules/corporates/corporates.component';
import { ListCorporatesComponent } from './modules/corporates/list-corporates/list-corporates.component';
import { CreateCorporateComponent } from './modules/corporates/create-corporate/create-corporate.component';
import { CorporateService } from './services/corporate.service';
import { ViewCorporateComponent } from './modules/corporates/view-corporate/view-corporate.component';
import { UploadCorporateCSVComponent } from './modules/corporates/upload-corporate-csv/upload-corporate-csv.component';
import { PaidDetailsComponent } from './modules/accounts/view-account/invoices/paid-details/paid-details.component';
import { ListBranchesComponent } from './modules/corporates/list-branches/list-branches.component';
import { BranchService } from './services/branch.service';
import { UploadBranchLogoComponent } from './modules/corporates/upload-branch-logo/upload-branch-logo.component';
import { DeleteCorporateComponent } from './modules/corporates/delete-corporate/delete-corporate.component';
import { DeleteBranchComponent } from './modules/corporates/list-branches/delete-branch/delete-branch.component';
import { CustomValidatorService } from './services/custom-validator.service';
import { JaldeeVerifyLevelComponent } from './shared/components/jaldee-verify-level/jaldee-verify-level.component';
import { VerifyLogComponent } from './shared/components/jaldee-verify-level/verify-log/verify-log.component';
import { UpdateVerifyLevelComponent } from './shared/components/jaldee-verify-level/update-verify-level/update-verify-level.component';
// tslint:disable-next-line:max-line-length
import { VerifyLogDetailsComponent } from './shared/components/jaldee-verify-level/verify-log/verify-log-details/verify-log-details.component';
// tslint:disable-next-line:max-line-length
import { VersionUpdateComponent } from './modules/version/version-update/version-update.component';
import { NgOtpInputModule } from 'ng-otp-input';
import {VersionService } from './services/version.service';
import { VersionOtpComponent } from './modules/version/version-update/version-otp/version-otp.component';
// tslint:disable-next-line:max-line-length
import { UpdateBranchVerifyLevelComponent } from './modules/corporates/list-corporates/update-branch-verify-level/update-branch-verify-level.component';
import { LoginHistoryComponent } from './modules/login-history/login-history.component';
import { LoginHistoryService } from './services/login-history.service';
import { GeneralModule } from './general/general.module';
import { CancelStatementModule } from './shared/modules/cancel-statement/cancel-statement.module';
import { AccountLicenseModule } from './modules/accounts/view-account/license-details/account-license.module';
import { CorporateLicenseModule } from './modules/corporates/corporate-license/corporate-license.module';
// tslint:disable-next-line:max-line-length
import { JdnComponent } from './modules/corporates/jdn/jdn.component';
import { EnableDisableJDNComponent } from './modules/corporates/jdn/enable-disable-jdn/enable-disable-jdn.component';
import { UpdateSalesIdDialogComponent } from './modules/accounts/updat-salesid/update-salesid-dialog.component';
import { ChangeCommissionReportStatusComponent }
from './modules/sales/commission-report/change-commission-report-status/change-commission-report-status.component';
import { ConfirmDiscountComponent } from './modules/accounts/view-account/invoices/confirm-discount/confirm-discount.component';
import { UpdateSalesIdService } from './services/update-salesid.service';
import { ManualSubscriptionService } from './services/manual-subscription.service';
import { JaldeeReimburseComponent } from './modules/reports/jaldee-reimburse/jaldee-reimburse.component';
import { RecreateReportComponent } from './modules/reports/recreate-report/recreate-report.component';
import { CancelReportComponent } from './modules/reports/cancel-report/cancel-report.component';
import { UserComponent } from './modules/User/user.component';
import { UserListComponent } from './modules/User/user-list/user-list.component';
import { CreateUserComponent } from './modules/User/create-user/create-user.component';
import { ChangeStatusComponent } from './modules/User/change-status/change-status.component';
import { WindowRefService } from './services/window-ref.service';
import { UserService } from './services/user.service';
import { ViewUserComponent } from './modules/User/view-user/view-user.component';
import { MarketingLoginComponent } from './marketing/marketing-login.component';
import { VirtualCallingComponent } from './modules/accounts/virtual-calling/virtual-calling.component';
import { UploadDataConfirmComponent } from './modules/accounts/view-account/account-details/upload-data-confirm/upload-data-confirm.component';
import { UploadAccountDataConfirmComponent } from './modules/accounts/view-account/account-details/upload-account-data-confirm/upload-account-data-confirm.component';
import { DeleteAccountVerifyyComponent } from './modules/accounts/account-filter/delete-account-verifyy/delete-account-verifyy.component';
import { ChangePhoneComponent } from './modules/customer/change-phone/change-phone.component';
import { SalesChannelInvoiceStatusComponent } from './modules/sales/sales-channel-invoice/sales-channel-invoice-status/sales-channel-invoice-status.component';
import { AccountUserService } from './services/account-user.service';
import { UnverifiedAccountService } from './services/unverified-account.service';
import { ReimbursementReportComponent } from './modules/reimbursement-Report/reimbursement-report.component';
import { ReimbursementReportListComponent } from './modules/reimbursement-Report/reimbursement-report-list/reimbursement-report-list.component';
import { ViewReimbursementReportComponent } from './modules/reimbursement-Report/view-reimbursement-report/view-reimbursement-report.component';
import { UnverifiedAccountsComponent } from './modules/Unverified-Accounts/unverified-accounts.component';
import { UnverifiedAccountListComponent } from './modules/Unverified-Accounts/unverified-account-list/unverified-account-list.component';
import { UploadServiceConfirmComponent } from './modules/accounts/view-account/account-details/upload-service-confirm/upload-service-confirm.component';
import { UnverifiedViewComponent } from './modules/Unverified-Accounts/unverified-view/unverified-view.component';
import { ConfirmRemoveDiscountComponent } from './modules/accounts/view-account/invoices/confirm-removediscount/confirm-removediscount.component';
import { UploadSettingsComponent } from './modules/accounts/view-account/account-details/upload-settings/upload-settings.component';
import { UpdateInfoComponent } from './modules/accounts/view-account/account-details/update-info/update-info.component';
import { AccountStatComponent } from './modules/bookingstat/account-stat.component';
import { BookingStatListComponent } from './modules/bookingstat/booking-stat-list/booking-stat-list.component';
import { BookingstatViewComponent } from './modules/bookingstat/bookingstat-view/bookingstat-view.component';
import { BookingViewComponent } from './modules/bookingview/bookingview.component';
import { ChangeRealComponent } from './modules/customer/change-real/change-real.component';
import { PaymentStatComponent } from './modules/paymentstat/payment-stat.component';
import { ItemViewComponent } from './modules/bookingview/item-view/item-view.component';
import { QuestionUploadComponent } from './modules/accounts/account-filter/question-upload/question-upload.component';
import { QuestionViewComponent } from './modules/accounts/view-account/question-view/question-view.component';
import { QuestionListViewComponent } from './modules/accounts/view-account/questionlist-view/questionlist-view.component';
import { ChangeStatusQuestionComponent } from './modules/accounts/view-account/change-status-question/change-status-question.component';
import { AdvancepayDialogComponent } from './modules/accounts/view-account/payment-settings/advancepay-dialog/advancepay-dialog.component';
import { LabelComponent } from './modules/labels/label.component';
import { ListLabelComponent } from './modules/labels/list-label/list-label.component';
import { CreateLabelComponent } from './modules/labels/create-label/create-label.component';
import { ChangeLabelStatusComponent } from './modules/labels/change-label-status/change-label-status.component';
import { ViewLabelComponent } from './modules/labels/view-label/view-label.component';
import { ApplyLabelComponent } from './modules/accounts/account-filter/apply-label/apply-label.component';
import { SendMessageComponent } from './modules/accounts/send-message/send-message.component';
import { JaldeeOffersComponent } from './modules/jaldee-offers/jaldee-offers.component';
import { IssueJcashComponent } from './modules/customer/issue-jcash/issue-jcash.component';
import { PaymentStatListComponent } from './modules/paymentstat/payment-stat-list/payment-stat-list.component';
import { PaytmService } from './services/paytm.service';
import { PaymentDetailsComponent } from './modules/accounts/view-account/payment-details/payment-details.component';
import { PayProfileUploadComponent } from './modules/accounts/account-filter/payprofile-upload/payprofile-upload.component';
import { CustomizedJsonUploadComponent } from './modules/accounts/account-filter/customizedjson-upload/customizedjson-upload.component';
import { PublishStatementDialogComponent } from './modules/jaldee-subscription/subscription-manualstatements/publish-statement-dialog/publish-statement-dialog.component';
import { BankinfoCreationDialogComponent } from './modules/accounts/view-account/payment-details/bankinfo-creation/bankinfo-creation-dialog.component';
import { DefaultProfileDialogComponent } from './modules/accounts/view-account/payment-details/default-profile-dialog/default-profile-dialog.component';
import { AccountUserComponent } from './modules/account-user/account-user.component';
import { AccountUserListComponent } from './modules/account-user/account-user-list/account-user-list.component';
import { ChangeStatusRealComponent } from './modules/accounts/change-status-real/change-status-real.component';
import { ViewAccountUserComponent } from './modules/account-user/view-account-user/view-account-user.component';
import { NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomTemplatesComponent } from './modules/accounts/view-account/account-details/custom-templates/custom-templates.component';
import { TemplateViewComponent } from './modules/accounts/view-account/account-details/custom-templates/template-view/template-view.component';
import { Template1Component } from './modules/accounts/view-account/account-details/custom-templates/template1/template1.component';
import { Template2Component } from './modules/accounts/view-account/account-details/custom-templates/template2/template2.component';
import { Template3Component } from './modules/accounts/view-account/account-details/custom-templates/template3/template3.component';
import { ManagePwaComponent } from './modules/accounts/view-account/account-details/manage-pwa/manage-pwa.component';
import { SafeHtmlModule } from './pipes/safe-html/safehtml.module';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { Template4Component } from './modules/accounts/view-account/account-details/custom-templates/template4/template4.component';
import { UploadPaymentProfileComponent } from './shared/components/upload-payment-profile/upload-payment-profile.component';
import { PaymentHistoryComponent } from './modules/accounts/view-account/payment-history/payment-history.component';
import { InvoiceDialogHistoryComponent } from './modules/accounts/view-account/payment-history/invoice-dialog/invoice-dialog-history.component';
import { ConsumerslistUploadComponent } from './modules/accounts/account-filter/consumerslist-upload/consumerslist-upload.component';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSortModule } from '@angular/material/sort';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import {TableModule} from 'primeng/table';
import { AnalyticsHomeComponent } from './modules/analytics/analytics-home/analytics-home.component';
import { AnalyticsComponent } from './modules/analytics/analytics.component';
import { AnalyticsFilterComponent } from './modules/analytics/analytics-filter/analytics-filter.component';
import { AnalyticsListComponent } from './modules/analytics/analytics-list/analytics-list.component';
import { JadeeHomeoComponent } from './modules/accounts/jaldee-homeo/jaldee-homeo.component';
import { AddNoteComponent } from './modules/reimbursement-Report/add-note/add-note.component';
import { StatementBysystemComponent } from './modules/accounts/view-account/license-details/statement-bysystem/statement-bysystem.component';
import { PrintStatementComponent } from './modules/jaldee-subscription/subscription-statements/statements/statement-list/print-statement/print-statement.component';
import { SectionViewComponent } from './modules/accounts/view-account/section-view/section-view.component';
import { SectionDetailsComponent } from './modules/accounts/view-account/section-view/section-details/section-details.component';
import { TemplateCreateComponent } from './modules/accounts/view-account/section-view/template-create/template-create.component';
import { SectionEditComponent } from './modules/accounts/view-account/section-view/section-edit/section-edit.component';
import { AppsListComponent } from './modules/accounts/view-account/apps-list/apps-list.component';
import { AppRegisterComponent } from './modules/accounts/view-account/apps-list/app-register/app-register.component';
import { DataMigrationListComponent } from './modules/accounts/view-account/data-migration-list/data-migration-list.component';
import { UploadDataComponent } from './modules/accounts/view-account/data-migration-list/upload-data/upload-data.component';
import { MigrateFileComponent } from './modules/accounts/view-account/data-migration-list/migrate-file/migrate-file.component';
import { RevertFileComponent } from './modules/accounts/view-account/data-migration-list/revert-file/revert-file.component';
import { ViewDataComponent } from './modules/accounts/view-account/data-migration-list/view-data/view-data.component';
import { ConsentFormComponent } from './modules/accounts/view-account/consent-form/consent-form.component';
import { CreateConsentFormComponent } from './modules/accounts/view-account/consent-form/create-consent-form/create-consent-form.component';
import { ChangeFormStatusComponent } from './modules/accounts/view-account/consent-form/change-form-status/change-form-status.component';
import { ExportComponent } from './modules/accounts/view-account/data-migration-list/export/export.component';
import { ChangeProformStatusDialogComponent } from './modules/jaldee-subscription/proforma-invoice/change-proform-status-dialog/change-proform-status-dialog.component';
import { PrintProformaComponent } from './modules/jaldee-subscription/proforma-invoice/print-proforma/print-proforma.component';
@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        AppheaderComponent,
        AppfooterComponent,
        AppsettingsComponent,
        AppmenuComponent,
        DashboardComponent,
        AuditsComponent,
        CustomerComponent,
        LabelComponent,
        ListLabelComponent,
        AccountsComponent,
        MaintanenceComponent,
        AccountUserComponent,
        AccountStatComponent,
        AccountUserListComponent,
        PaymentStatComponent,
        // BookingStatList1Component,
        BookingStatListComponent,
        PaymentStatListComponent,
        UnverifiedAccountsComponent,
        UnverifiedAccountListComponent,
        UnverifiedViewComponent,
        ItemViewComponent,
        QuestionListViewComponent,
        ChangeStatusQuestionComponent,
        BookingstatViewComponent,
        HealthComponent,
        HomeComponent,
        DateFormatPipe,
        AccountListComponent,
        AccountHomeComponent,
        DeleteCustomerDialogComponent,
        ChangeRealComponent,
        ViewHealthComponent,
        ListHealthComponent,
        ChangePasswordDialogComponent,
        ChangeStatusDialogComponent,
        ChangeStatusComponent,
        DeleteAccountDialogComponent,
        UpdateSalesIdDialogComponent,
        ChangeAccstatusDialogComponent,
        ChangeStatusRealComponent,
        JadeeHomeoComponent,
        BreadcrumbComponent,
        AccountFilterComponent,
        AccountDetailsComponent,
        PaymentSettingsComponent,
        QuestionViewComponent,
        VirtualCallingComponent,
        InvoicesComponent,
        UploadDataConfirmComponent,
        UploadSettingsComponent,
        UpdateInfoComponent,
        UploadServiceConfirmComponent,
        UploadAccountDataConfirmComponent,
        TransactionsComponent,
        PaymentHistoryComponent,
        ViewAccountComponent,
        VerifyAccountDialogComponent,
        ViewCustomerComponent,
        ListCustomerComponent,
        UserListComponent,
        ViewUserComponent,
        ViewAccountUserComponent,
        ReimbursementReportComponent,
        ReimbursementReportListComponent,
        InvoiceDialogComponent,
        InvoiceDialogHistoryComponent,
        ConfirmDiscountComponent,
        ConfirmRemoveDiscountComponent,
        DisplayResultDialogComponent,
        GatewayDialogComponent,
        ConfirmEqualValidatorDirective,
        VerifyModalComponent,
        SupportLoginComponent,
        MarketingLoginComponent,
        SupportDashboardComponent,
        SupportHomeComponent,
        SupportAccountsComponent,
        SupportMainComponent,
        PaytmVerifyDialogComponent,
        MerchantidDialogComponent,
        RemoveadwordDialogComponent,
        ChangeSubscriptionDialogComponent,
        StatementBysystemComponent,
        EmailVerifyDialogComponent,
        SafePipe,
        CouponsComponent,
        CouponListComponent,
        CreateCouponDialogComponent,
        DeleteCouponComponent,
        DisableCouponComponent,
        PushCouponComponent,
        ViewCouponComponent,
        ReportsComponent,
        JaldeeReportComponent,
        JaldeeReimburseComponent,
        ViewJaldeeReportComponent,
        ViewReimbursementReportComponent,
        ReimburseDialogComponent,
        AddNoteComponent,
        RecreateReportComponent,
        CancelReportComponent,
        ChangeInvoiceStatusDialogComponent,
        ChangeProformStatusDialogComponent,
        AccountPaymentListComponent,
        AwsSearchComponent,
        CommonAccountFilterComponent,
        ChangePhoneNumberComponent,
        ChangePhoneComponent,
        SearchDetailComponent,
        DeleteAccountVerifyComponent,
        DeleteAccountVerifyyComponent,
        MarkAsPaidComponent,
        CorporatesComponent,
        ListCorporatesComponent,
        CreateCorporateComponent,
        ListLabelComponent,
        CreateLabelComponent,
        ViewCorporateComponent,
        UploadCorporateCSVComponent,
        PrintStatementComponent,
        PrintProformaComponent,
        CreateUserComponent,
        PaidDetailsComponent,
        ListBranchesComponent,
        UploadBranchLogoComponent,
        DeleteCorporateComponent,
        DeleteBranchComponent,
        JaldeeVerifyLevelComponent,
        VerifyLogComponent,
        UpdateVerifyLevelComponent,
        VerifyLogDetailsComponent,
        VersionUpdateComponent,
        VersionOtpComponent,
        UpdateBranchVerifyLevelComponent,
        LoginHistoryComponent,
        UserComponent,
        BookingViewComponent,
        JdnComponent,
        QuestionUploadComponent,
        ConsumerslistUploadComponent,
        EnableDisableJDNComponent,
        ChangeCommissionReportStatusComponent,
        SalesChannelInvoiceStatusComponent,
        AdvancepayDialogComponent,
        ChangeLabelStatusComponent,
        ViewLabelComponent,
        ApplyLabelComponent,
        SendMessageComponent,
        JaldeeOffersComponent,
        IssueJcashComponent,
        PaymentDetailsComponent,
        BankinfoCreationDialogComponent,
        DefaultProfileDialogComponent,
        PayProfileUploadComponent,
        CustomizedJsonUploadComponent,
        PublishStatementDialogComponent,
        ManagePwaComponent,
        CustomTemplatesComponent,
        TemplateViewComponent,
        Template1Component,
        Template2Component,
        Template3Component,
        Template4Component,
        UploadPaymentProfileComponent,
        AnalyticsHomeComponent, 
    AnalyticsComponent,
    AnalyticsFilterComponent,
    AnalyticsListComponent,
    SectionViewComponent,
    SectionDetailsComponent,
    TemplateCreateComponent,
    SectionEditComponent,
    AppsListComponent,
    AppRegisterComponent,
    DataMigrationListComponent,
    UploadDataComponent,
    MigrateFileComponent,
    RevertFileComponent,
    ViewDataComponent,
    ConsentFormComponent,
    CreateConsentFormComponent,
    ChangeFormStatusComponent,
    ExportComponent
    ],
    imports: [
        AppRouting,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        MatTableModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        BrowserAnimationsModule,
        NgArrayPipesModule,
        MatDialogModule,
        MatTabsModule,
        UiSwitchModule,
        MessageDisplayModule,
        MatSortModule,
        MatButtonModule,
        MatMenuModule,
        MatToolbarModule,
        MatTooltipModule,
        MatIconModule,
        MatCardModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatRadioModule,
        MatSelectModule,
        MatTabsModule,
        MatOptionModule,
        MatSlideToggleModule,
        MatExpansionModule,
        // AngularDateTimePickerModule,
        MatSnackBarModule,
        NgxChartsModule,
        NgOtpInputModule,
        GeneralModule,
        MessageDisplayModule,
        CancelStatementModule,
        AccountLicenseModule,
        CorporateLicenseModule,
        NgbTimepickerModule,
        CKEditorModule,
        SafeHtmlModule,
        MatCheckboxModule,
        TableModule
    ],
    exports: [
        MatTabsModule,
        MatButtonModule,
        MatMenuModule,
        MatToolbarModule,
        MatTooltipModule,
        MatIconModule,
        MatCardModule,
        BrowserAnimationsModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatRadioModule,
        MatSelectModule,
        MatOptionModule,
        MatTabsModule,
        MatSlideToggleModule,
        MatExpansionModule,
        MatSnackBarModule,
        MatCheckboxModule,
        SafeHtmlModule,
    ],
    providers: [
        AuthenticationService,
        CommonfilterService,
        User,
        RenewLicense,
        DashboardService,
        AuditService,
        AccountService,
        CustomerService,
        CouponService,
        CustomValidatorService,
        JaldeeReportService,
        HealthService,
        AuthGuard,
        DateFormatPipe,
        AccountDataSourceService,
        MaintenanceService,
        AccountResolverService,
        CouponService,
        FileUploadService,
        UserService,
        AccountUserService,
        UnverifiedAccountService,
        UpdateSalesIdService,
        WindowRefService,
        LoginHistoryService,
        { provide: MatPaginatorIntl, useClass: MatPaginatorCustom },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        PaginationService,
        JaldeeReportResolverService,
        {
            provide: HTTP_INTERCEPTORS,
            useFactory: function (router: Router) {
                return new AuthInterceptorService(router);
            },
            multi: true,
            deps: [Router]
        },
        // supportServices
        SupportAccountService,
        SupportAccountDataSourceService,
        SharedServices,
        SearchDataStorageService,
        ServiceMeta,
        SharedFunctions,
        SearchDetailServices,
        CorporateService,
        BranchService,
        PaytmService,
        ManualSubscriptionService,
        VersionService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent]
})
export class AppModule { }
